import { useMemo } from "react";
import { useLocationRuleGroupByRuleType } from "./useLocationRuleGroupByRuleType";

interface Params {
  rules: string[];
}
export const useRuleGroupByLocation = (params: Params) => {
  const { data: ruleGroup, isLoading: isLoadingRuleGroup } =
    useLocationRuleGroupByRuleType(params.rules);

  const data = useMemo(() => {
    if (isLoadingRuleGroup) {
      return undefined;
    }

    const groupByLocation = Object.entries(ruleGroup).reduce(
      (acc, [_, locations]) => {
        Object.entries(locations).forEach(([locationKey, items]) => {
          if (!acc[locationKey]) {
            acc[locationKey] = [];
          }
          acc[locationKey] = acc[locationKey].concat(items);
        });
        return acc;
      },
      {} as Record<
        string,
        {
          channel: number;
          deviceId: string;
          locationId: string;
          locationName: string;
          ruleName: string;
          ruleType: string;
          cameraName: string;
        }[]
      >
    );

    return groupByLocation;
  }, [isLoadingRuleGroup, ruleGroup]);

  return {
    data,
    isLoading: isLoadingRuleGroup
  };
};
